import fs from 'fs';
import path from 'path';

export function writeFile(filePath: string, content: string) {
	const folderPath = path.dirname(filePath);

	fs.mkdirSync(folderPath, { recursive: true });

	fs.writeFileSync(filePath, content, 'utf8');
}
